import React from "react";
import "./industry.css";
import Particles from "../Particles/Particles";

const Industry = () => {
  return (
    <div className="industry-wrapper">
      <Particles title="Industry" subTitle="Know About Our Industries" />
    </div>
  );
};

export default Industry;
